import React, { ReactElement } from 'react'
import { UserAccount } from './UserAccount'

export const Profile = (id: string): ReactElement => (
  <>
    <UserAccount userId={id || 'new'} />
  </>
)
